import styled, { css } from "styled-components";
import { CssRule } from "../../../../../themes/architecture/css-helpers/css-rule";

export const SwiperButtonBox = styled.div<{hideOnRealMobile?: boolean}>`
    margin: 0 0.5rem;

    ${({hideOnRealMobile}) => hideOnRealMobile ? css`
        ${CssRule.For.realMobile.build()} &{
            display: none;
        }
    ` : null}
`;
